<template>
  <div class="index_dynamic">
    <div class="person-wrap" ref="personWrap">
      <ul ref="personTab">
        <li
          class="scroll-view-item_W"
          v-for="(item,index) in list"
          :key="index"
          @click="tapDynamicDetail(item)"
        >
          <div class="text_tit">{{item.wxtitle || item.title}}</div>
          <div class="bar_mid">
            <img v-lazy="item.banner_imgurl" width="50%" height="150px" />
            <span>{{item.wxdesc}}</span>
          </div>
          <!-- <span class="scroll-view-b">{{item.readCount}}人阅读</span> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import BScroll from "better-scroll";
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  props: {
    list: Array
  },
  data() {
    return {
      scroll: null
    };
  },
  watch: {},
  computed: {
    ...mapState(["userInfo", "receiveSpreadInfo", "isInMiniProgram"])
  },
  methods: {
    personScroll() {
      if (this.list) {
        // 默认有六个li子元素，每个子元素的宽度为120px
        let width = this.list.length * 300;
        this.$refs.personTab.style.width = width + "px";
        // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.personWrap, {
              startX: 0,
              click: true,
              scrollX: true,
              // 忽略竖直方向的滚动
              scrollY: false,
              eventPassthrough: "vertical"
            });
          } else {
            this.scroll.refresh();
          }
        });
      }
    },
    tapDynamicDetail(item) {
      if (item.h5PageUrlHttps) {
        // lj04
        util.openYqRsH5Link(item.h5PageUrlHttps);
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.personScroll();
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.person-wrap {
  overflow: hidden;
}

.scroll-view-item_W {
  width: 280px;
  background: #fff;
  margin: 10px 5px 10px 15px;
  display: inline-block;
  border-radius: 0.1rem;
  /*box-shadow: 0 0 0.25rem #cbcbcb;*/
  box-shadow: 0px 0px 10px 0px rgba(35,24,21,0.1);
  padding-bottom: 0.2rem;
  padding-top: 0.1rem;
}

.scroll-view-item_W .text_tit {
  /*margin: 0.125rem 5%;*/
  padding-left: 5%;
  line-height: .6rem;  
  display: block;
  font-size: 0.3rem;
  font-weight: bold;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bar_mid {
  width: 90%;
  margin-left: 5%;
  height: 1.6rem;
}

.bar_mid > img {
  width: 55%;
  height: 1.6rem;
  float: left;
}

.bar_mid > span {
  width: 40%;
  line-height: 0.5rem;
  display: -webkit-box;
  white-space: pre-wrap;
  float: left;
  font-size: 0.25rem;
  height: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  padding-left: 0.125rem;
  text-align: justify;
}

.scroll-view-b {
  width: 90%;
  margin-left: 5%;
  font-size: 0.3rem;
  margin-top: 0.1rem;
  display: inline-block;
}
</style>